import React, { useEffect } from 'react'
import styled from '@emotion/styled'
import mq from '../mediaQuery'
import PremiumFeatures from '../components/Premium/PremiumFeatures'
import { useMutation, useQuery } from '@apollo/client'
import { GET_REGISTRATIONS_SUBGRAPH } from '../graphql/queries'
import moment from 'moment/moment'
import Loader from '../components/Loader'
import SelectorButton from '../components/Premium/SelectorButton'
import { UPGRADE_DOMAIN } from '../graphql/mutations'
import { ethers } from '@ace_domains/ui'
import { premiumFeaturesContent } from '../constants/premiumFeatures'
import { regularFeaturesContent } from '../constants/regularFeatures'
import Button from '../components/Forms/Button'


const PremiumContainer = styled('div')`
  display: flex;
  flex-direction: column;
  margin: 0.5em;
  padding: 20px 20px;
  width: 95%;
  height: auto;
  background-color: inherit;
  color: #e8ebfc;
  border-radius: 8px;
  ${mq.xLarge`
    width: 100%;
    padding: 40px 20px;
  `}
`
const PremiumDetail = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 80%;
  ${mq.xLarge`
    flex-direction: row;
  `}
`
const PremiumDetailBottom = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-top: 2em;
  height: 20%;
`
const DomainListContainer = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 20px 20px;
  margin: 0.5em;
  height: auto;
  min-height: 280px;
  max-height: 390px;
  background-color: #c7bfff33;
  border-radius: 8px;
  ${mq.xLarge`
    width: 30%;
  `}
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 10px;
    border: 1px none #B8860B;
    border-radius: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: #B8860B;
    border-radius: 5px;
  }
`
const PremiumFeatureContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 20px 40px;
  margin: 0.5em;
  height: 100%;
  background-color: #c7bfff33;
  border-radius: 8px;
  ${mq.xLarge`
    width: 70%;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
  `}
`
const StyledButton = styled('button')`
  width: 300px;
  height: 40px;
  background: #F0C17D;
  //box-shadow: inset 0px 0px 5px 4px #F0C17D;
  border-radius: 5px;
  color: #36174D;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  font-style: normal;
`
const Header = styled('div')`
  //position: fixed;
  border-bottom: thin solid #D2CDCD;
  width: 100%;
  color: #D2CDCD;
  margin-bottom: 10px;
  //max-width: 20%;
`
const Text = styled('div')`
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 19px;
  margin-bottom: 5px;
`
const StyledCircle = styled('div')`
  height: 150px;
  min-width: 150px;
  border: 2px solid #F0C17D;
  border-radius: 50%;
  margin: 20px 10px;
  position: relative;
`
const StyledCircleInside = styled('div')`
  position: absolute;
  height: 130px;
  width: 130px;
  border: 1px solid #F0C17D;
  border-radius: 50%;
  top: 50%;
  left: 50%;
  margin: -65px 0 0 -65px;
  display: flex; /* or inline-flex */
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
const SuccessRate = styled('h2')`
  margin: 0;
  color: #F0C17D;
`
const SuccessText = styled('div')`
  color: #F0C17D;
  display: inherit;
  flex-direction: inherit;
  align-items: center;
`

const BoostedText = styled('div')`
  margin-top: 5px;
  font-size: larger;
  font-weight: bold
`

const SuccessContainer = styled('div')`
  display: flex;
  height: 250px;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  align-content: space-around;
  margin: 10px 0 20px 0;
`

function useDomains({
                      domainType,
                      address,
                    }) {

  let currentDate = moment()
  const registrationsQuery = useQuery(GET_REGISTRATIONS_SUBGRAPH, {
    variables: {
      id: address,
      first: 500,
      skip: 0,
      orderBy: 'labelName',
      orderDirection: 'asc',
      expiryDate: currentDate.subtract(90, 'days').unix()
    },
    skip: domainType !== 'registrant',
    fetchPolicy: 'no-cache'
  })

  return registrationsQuery
}


const PremiumPage = ({ match }) => {
  const address = match.params.address.toLowerCase()
  const [domainSelected, setDomainSelected] = React.useState(null)
  const [conversionRate, setConversionRate] = React.useState("0%")
  const [upgradeCost, setUpgradeCost] = React.useState(0)
  const [waiting, setWaiting] = React.useState(false)
  const [isBoosted, setIsBoosted] = React.useState(false)

  const { loading, data, error, refetch } = useDomains({
    domainType: 'registrant',
    address: address.toLowerCase(),
  })

  useEffect(() => {
    if (!domainSelected) return;
    if (!isBoosted){
      switch (domainSelected.name.length) {
        case 2:
          setConversionRate("60%")
          setUpgradeCost(10)
          break
        case 3:
          setConversionRate("33%")
          setUpgradeCost(8)
          break
        case 4:
          setConversionRate("17%")
          setUpgradeCost(6)
          break
        case 5:
        case 6:
        case 7:
          setConversionRate("11%")
          setUpgradeCost(4)
          break
        default:
          setUpgradeCost(0)
          setConversionRate("0%")
      }
    }
    if(isBoosted){
      switch (domainSelected.name.length) {
        case 2:
          setConversionRate("81%")
          setUpgradeCost(10 + 2.99)
          break
        case 3:
          setConversionRate("48%")
          setUpgradeCost(8 + 2.99)
          break
        case 4:
          setConversionRate("27%")
          setUpgradeCost(6 + 2.99)
          break
        case 5:
        case 6:
        case 7:
          setConversionRate("21%")
          setUpgradeCost(4 + 2.99)
          break
        default:
          setUpgradeCost(0)
          setConversionRate("0%")
      }
    }
  }, [domainSelected, isBoosted])

  const [mutation] = useMutation(UPGRADE_DOMAIN, {
    onCompleted: data => {
      console.log("mutation Data", data.upgradeDomain)
      if(data.upgradeDomain.txState === "Failed"){
        alert(`${data.upgradeDomain.errorMessage}`)
      }
    },
  })

  function handleUpgrade() {
    setWaiting(true)
    mutation({
      variables: {
        name: `${domainSelected.name}`,
        id: `${domainSelected.id}`,
        boosted: isBoosted,
      }
    }).then((res) => {
      const randomNumber = parseInt(res.data.upgradeDomain.events[0].args[2], 10)
      const successRate = parseInt(res.data.upgradeDomain.events[0].args[3], 10)
      if(res.data.upgradeDomain.events[0].event === "upgradeFailed"){
        alert(`Sorry, the upgrade failed! Try again!\nYour random number was ${((randomNumber/1.1579)/100).toFixed(2)} and the success rate was ${((successRate/1.1579)/100).toFixed(2)}%, being lower than 100% (${((randomNumber+successRate)/1.1579/100).toFixed(2)}%)`)
      }
      if(res.data.upgradeDomain.events[0].event === "upgradeSuccess"){
        alert(`Congrats! Your domain now its a Supreme Domain! 🎉\nYour random number was ${((randomNumber/1.1579)/100).toFixed(2)} and your total winning rate was ${((randomNumber+successRate)/1.1579/100).toFixed(2)}%`)
        refetch().then(r =>
          setDomainSelected(null)
        )
      }
    }).catch((e) => {
      console.log("Error", e)
    }).finally(() => {
      setWaiting(false)
    })
  }


  if (loading) {
    return <Loader withWrap large />
  }

  if (data.account === null) {
    return (
      <PremiumContainer>
        <div style={{display: "flex", justifyContent: "center"}}>
          No AceDomains Found on {address}
        </div>
      </PremiumContainer>
    )
  }

  return (
    <PremiumContainer>
      <PremiumDetail>
        <DomainListContainer>
          <Header>
            <Text>Eligible Domains</Text>
          </Header>
          <>
            {data.account.registrations.map((item, index) => {
              if (item.domain.labelName.length > 7 ) return null
              return (
                <div style={{width: "100%"}} key={index}>
                  <SelectorButton isSelected={domainSelected?.name === item.domain.labelName} onClick={(e) => {
                    e.preventDefault()
                    const labelHash = ethers.utils.keccak256(ethers.utils.toUtf8Bytes(item.domain.labelName))
                    const tokenId = ethers.BigNumber.from(labelHash).toString();
                    setDomainSelected({
                      name: item.domain.labelName,
                      id: tokenId,
                      isPremium: item.domain.premium
                    })
                  }} data={item.domain}/>
                </div>
              )
            })}
          </>
        </DomainListContainer>
        <PremiumFeatureContainer>
          <PremiumFeatures tittle={"Regular Domains"} items={regularFeaturesContent}/>
          <SuccessContainer>
            <StyledCircle>
              <StyledCircleInside>
                <SuccessRate>
                  {conversionRate}
                </SuccessRate>
                <SuccessText>
                  <div>Success Rate</div>
                  {isBoosted && (<BoostedText>Boosted!</BoostedText>)}
                </SuccessText>
              </StyledCircleInside>
            </StyledCircle>
            {domainSelected !== null && (
              <Button type={isBoosted ? "hollow-gold" : "hollow-premium"} onClick={(e) => setIsBoosted(!isBoosted)}>{isBoosted ? "UNBOOST" : "BOOST IT! 🚀"}</Button>
            )}
          </SuccessContainer>
          <PremiumFeatures tittle={"Supreme Domains"} items={premiumFeaturesContent}/>
        </PremiumFeatureContainer>
      </PremiumDetail>
      {domainSelected !== null && (
        <PremiumDetailBottom>
          <h2>Supreme Domains Sold Out!</h2>
          {/*{waiting*/}
          {/*  ? (*/}
          {/*    <div style={{backgroundColor: "#363755", display: "flex", justifyContent: "center", alignItems: "center", maxHeight: "50px", padding: "1em", borderRadius: "10px"}}>*/}
          {/*      <div style={{marginRight: "15px"}}>Waiting for confirmation...</div>*/}
          {/*      <Loader withWrap />*/}
          {/*    </div>*/}
          {/*  )*/}
          {/*  : <StyledButton*/}
          {/*    onClick={handleUpgrade}*/}
          {/*    disabled={domainSelected.isPremium || upgradeCost === 0}*/}
          {/*  >*/}
          {/*    {domainSelected.isPremium*/}
          {/*      ? "Domain Already Upgraded!"*/}
          {/*      : upgradeCost === 0*/}
          {/*        ? "Select a valid Domain"*/}
          {/*        :"Upgrade Now!"}*/}
          {/*  </StyledButton>}*/}

        </PremiumDetailBottom>
      )}

    </PremiumContainer>
  )
}

export default PremiumPage
